export default __webpack_public_path__ + "static/media/house-2.5bf5d2ae.jpg";